import { Text } from "../../../components/text/text";
import { useEffect, useState } from "react"
import { CalendarIcon, ClockIcon } from "../../../assets/icons"
import { Calendar } from "../../../components/calendar/calendar"
import { usePopup } from "../../../components/popup/popup"
import { WeekDayPopup } from "./weekDayPopup"
import { useParams } from "react-router"
import { AdminHeader } from "../../../components/adminHeader/adminHeader"
import TableAPI from "../../../api/TableAPI"
import classNames from "classnames"
import qs from "qs"
import { Button } from "../../../components/button/button"
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate"

import styles from "./tablePage.module.css"

const months = ["январе", "феврале", "марте", "апреле", "мае", "июне", "июле", "августе", "сентябре", "октябре", "ноябре", "декабре"]

export const SuperAdminWorkerTablePage = () => {
    const { cafeId, userId } = useParams();

    const [shifts, setShifts] = useState([]);
    const [total, setTotal] = useState({ shifts: 0, hours: 0 });
    const [date, setDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));

    const [Popup, open, close] = usePopup();
    const [popupParams, setPopupParams] = useState({ date: new Date(), curShift: null });

    const [isAdding, setIsAdding] = useState(false);
    const [selectedDays, setSelectedDays] = useState([]);

    const onDayClicked = (date, curShift) => {
        if (isAdding) {
            setSelectedDays(prev => {
                if (prev.some(el => el.getTime() === date.getTime())) {
                    return prev.filter(d => d.getTime() !== date.getTime());
                } else {
                    return [...prev, date];
                }
            });
        } else {
            setPopupParams({ date, curShift });
            open();
        }
    }

    const navigate = useAnimatedNavigate();
    const onAddClick = () => {
        if (!isAdding) {
            setIsAdding(true);
            return;
        }
        if (selectedDays.length === 0) return;
        const query = qs.stringify({
            dates: selectedDays.map(d => d.getTime()),
        });
        navigate(`/superadmin/cafe/${cafeId}/employees/${userId}/table/add?${query}`);
    }

    useEffect(() => {
        if (!cafeId) return;

        TableAPI
            .fetchEmployeeTotalShifts(userId, date.getFullYear(), date.getMonth() + 1)
            .then(res => setTotal(res))
            .catch(console.error);

        TableAPI
            .fetchEmployeeShifts(userId, cafeId, date.getFullYear(), date.getMonth() + 1)
            .then(res => setShifts(res))
            .catch(console.error);
    }, [date, cafeId, userId]);

    const onDeleteShift = async (date) => {
        setShifts(prev => prev.filter(el => el.shiftDate !== date.toISOString().split("T")[0]));
        close();

        const updatedTotal = await TableAPI.fetchEmployeeTotalShifts(
            userId,
            date.getFullYear(),
            date.getMonth() + 1
        );
        setTotal(updatedTotal);
    }

    return (
        <>
            <AdminHeader title="Табель" userId={userId} />

            <div className={styles.brief_info}>
                <div className={styles.brief_info_item}>
                    <CalendarIcon className={styles.brief_item_icon} />
                    <Text as="div" variant="body" className={styles.brief_item_text} >Смен в {months[date.getMonth()]}: {total.shifts}</Text>
                </div>
                <div className={styles.brief_info_item}>
                    <ClockIcon className={styles.brief_item_icon} />
                    <Text as="div" variant="body" className={styles.brief_item_text} >Часов в {months[date.getMonth()]}: {total.hours.toFixed(0)}</Text>
                </div>
            </div>

            <Calendar date={date} setDate={setDate} shifts={shifts} onClick={onDayClicked} shiftType={shift => !!shift ? "shift" : "primary"} selectedDates={selectedDays} />

            <div className={styles.explanation_container}>
                <div className={classNames(styles.explanation_item, styles.shift)}>Рабочие смены</div>
            </div>

            <Popup>
                <WeekDayPopup date={popupParams.date} shift={popupParams.curShift} onDelete={onDeleteShift} />
            </Popup>

            <div className={classNames(styles.add_shifts_container, { [styles.active]: isAdding })}>
                <div style={{
                    overflow: "hidden",
                    minWidth: "0px",
                }}>
                    <Button
                        style={{ marginRight: "10px" }}
                        text="Отменить"
                        type="secondary"
                        onClick={() => {
                            setIsAdding(false);
                            setSelectedDays([]);
                        }}
                    />
                </div>
                <Button
                    text={isAdding ? "Подтвердить" : "Назначить смены"}
                    onClick={onAddClick}
                />
            </div>
        </>
    )
}
